function defer(fn) {
    return requestAnimationFrame(fn);
}
function cancelDefer(deferId) {
    if (null !== deferId) cancelAnimationFrame(deferId);
}
export { cancelDefer, defer };
